import { dispatchEvent } from '@/helpers/DispatchEvent'
import ValidationError from '@/errors/ValidationError'

export function reportFormValidity(form: HTMLFormElement): Promise<void> {
  return new Promise((resolve, reject) => {
    // Workaround: defer fields' validity checks
    // On touch devices, `setCustomValidity` in `FormInput2` happens after the validity
    // check for the autocomplete address hence this workaround

    const start = Date.now()
    setTimeout(() => {
      const duration = Date.now() - start
      /* eslint-disable no-console */
      console.log('reportFormValidity() setTimeout duration', `${duration}ms`)
      if (form) {
        const fields = form.querySelectorAll('input, select')

        for (const field of fields as NodeListOf<HTMLInputElement | HTMLSelectElement>) {
          const valid = field.checkValidity()
          if (!valid) {
            dispatchEvent('invalid', field)
          } else {
            dispatchEvent('validate', field)
          }
        }

        // Get the first invalid field.
        const field = form.querySelector(':invalid') as HTMLInputElement
        if (field) {
          field.scrollIntoView()
          // Scroll up a bit more.
          window.scrollBy(0, -30)

          console.log('form validation failed', form, field)
          reject(new ValidationError())
        }
      }
      resolve()
    })
  })
}

export function formIsValid(form: HTMLFormElement): boolean {
  const fields = form.querySelectorAll('input, select')

  for (const field of fields as NodeListOf<HTMLInputElement | HTMLSelectElement>) {
    if (!field.validity.valid) {
      return false
    }
  }

  return true
}
